export const MENU_REG = /^pm_[\w-]+$/;

export default { MENU_REG };
